import { render, staticRenderFns } from "./AllocationSchedule6.vue?vue&type=template&id=395f3075"
import script from "./AllocationSchedule6.vue?vue&type=script&lang=js"
export * from "./AllocationSchedule6.vue?vue&type=script&lang=js"
import style0 from "./AllocationSchedule6.vue?vue&type=style&index=0&id=395f3075&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports